module.exports = __webpack_public_path__ + "media/components/VendingCart/assets/click-here-to-customize-your-cart-34b7544f12a06ade034df7dcc1710828.png";